import { UpdatesQuery } from './Updates.query';

export const Updates = () => {
  return <UpdatesQuery />;
};
